import { apiPost } from "../../../utils/api";
import { getDeviceId } from "../../../api/token";
import { RegisterDeviceTokenDto } from "../type/notification.types";

/**
 * Backend endpoints for associating this browser's FCM token with the logged-in
 * user. Adjust these paths to match the API once the routes are finalized.
 */
const REGISTER_TOKEN_ENDPOINT = "fcm_token/register";

/**
 * Registers the FCM token with the backend so the server can push to this
 * browser. The token is keyed by the app's existing per-device id.
 */
export const registerDeviceToken = async (token: string): Promise<void> => {
  const payload: RegisterDeviceTokenDto = {
    token,
    deviceId: getDeviceId(),
    platform: "web",
  };
  await apiPost(REGISTER_TOKEN_ENDPOINT, payload);
};
